module.exports = __webpack_public_path__ + "img/20191002133420932.d973ad76.jpg";